<script setup lang="ts">
import { computed, defineEmits, defineProps } from 'vue'
import { useAdminStore } from '@voix/store/adminStore'

import type { PropType } from 'vue'

import type {
  FieldConfigInterface,
  FieldInterface,
  SliceInterface,
} from '@voix/types'

const props = defineProps({
  slice: {
    type: Object as () => SliceInterface,
    required: true,
  },
  group: {
    type: Object as PropType<Record<string, FieldConfigInterface>>,
    required: true,
  },
})

defineEmits(['selectElement'])

const adminStore = useAdminStore()

function selectGroup() {
  const groupWithFullFieldConfiguration = Object.assign({}, props.group)

  // Loop through group and add the field name to each field configuration
  Object.keys(groupWithFullFieldConfiguration).forEach((fieldName) => {
    const fieldConfiguration = groupWithFullFieldConfiguration[fieldName]
    groupWithFullFieldConfiguration[fieldName] = Object.assign({}, fieldConfiguration, {
      name: fieldName,
    })
  })

  adminStore.toggleSelectGroup(props.slice, groupWithFullFieldConfiguration)
}

const groupIsSelected = computed(() => {
  return (
    adminStore.selectedFieldSlice
    && adminStore.selectedFieldSlice === props.slice
    && adminStore.selectedGroup
    && adminStore.selectedGroup === props.group
  )
})

// This is the label for the group.
const groupLabel = computed(() => {
  return Object.values(props.group)[0].group
})
</script>

<template>
  <div>
    <button class="w-full outline-none" @click.left.exact.stop="selectGroup">
      <div
        class="w-full flex space-x-1 items-center py-2.5 px-4 transition-colors duration-200"
        :class="[
          {
            'voix-admin-bg-light voix-admin-text-darkest': groupIsSelected,
            'voix-admin-text hover:voix-admin-text-darkest':
              !groupIsSelected,
          },
        ]"
      >
        <Icon name="heroicons:rectangle-group-20-solid" />
        <div class="truncate select-none text-xs">
          {{ groupLabel }}
        </div>
      </div>
    </button>
  </div>
</template>
